import { loggerType } from "core/modules/config/loggerConfig"

import { AirbrakeLogger } from "./AirbrakeLogger"
import { LogLevel, type Logger } from "./BaseLogger"
import { ConsoleLogger } from "./ConsoleLogger"

export { Logger, LogLevel }

export const logger = loggerType === "airbrake" ? AirbrakeLogger : ConsoleLogger
